import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement> & { size?: number }

const make = (d: string) => ({ size = 20, ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    <path d={d} />
  </svg>
)

export const DashboardIcon = make('M3 13h8V3H3v10Zm10 8h8V3h-8v18Z')
export const ProspectsIcon = make('M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m18-11a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z')
export const SequencesIcon = make('M4 4h16v4H4V4Zm0 6h16v4H4v-4Zm0 6h10v4H4v-4Z')
export const OutreachIcon = make('M21 15V5a2 2 0 0 0-2-2H7l-4 4v8a2 2 0 0 0 2 2h5l5 5v-5h2a4 4 0 0 0 4-4Z')
export const ComplianceIcon = make('M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z')
export const HelpIcon = make('M12 17h.01M12 13a3 3 0 1 0-3-3')
export const ChatIcon = make('M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-4.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5')
export const PlaybookIcon = make('M4 19.5A2.5 2.5 0 0 1 6.5 17H20m-16 2.5A2.5 2.5 0 0 0 6.5 22H20V2H6.5A2.5 2.5 0 0 0 4 4.5v15Z')
export const CampaignIcon = make('M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Zm4 18H6V4h7v5h5v11Z')
export const AnalyticsIcon = make('M3 3v18h18M18 17V9m-5 8v-6m-5 6v-3')
export const SettingsIcon = make('M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z')
export const DollarSignIcon = make('M12 2v20M17 5H9.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H6')
export const FlaskIcon = make('M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2M8.5 2h7M7 16h10')
export const QueueIcon = make('M3 6h2v12H3V6Zm4 0h2v12H7V6Zm4 0h2v12h-2V6Zm4 0h2v12h-2V6Zm4 0h2v12h-2V6Z')
export const ZapIcon = make('M13 2 3 14h9l-1 8 10-12h-9l1-8Z')
export const FlameIcon = make('M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5Z')
export const VideoIcon = make('m22 8-6 4 6 4V8ZM4 6h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z')
export const MegaphoneIcon = make('m3 11 18-5v12L3 14v-3Zm0 0v3M11 14l.5 5a1 1 0 0 0 1 .9h.5a1 1 0 0 0 1-.9l.5-5')
export const TrendingUpIcon = make('M22 7 13.5 15.5 8.5 10.5 2 17M22 7h-6M22 7v6')
export const MemoryIcon = make('M12 2a3 3 0 0 0-3 3v1a3 3 0 1 0 6 0V5a3 3 0 0 0-3-3ZM9 8v.59a5.001 5.001 0 0 0-4 4.91v4a5 5 0 0 0 5 5h4a5 5 0 0 0 5-5v-4a5.001 5.001 0 0 0-4-4.91V8M8 15h.01M12 15h.01M16 15h.01')
export const GlobeIcon = make('M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10Z')
export const BellIcon = make('M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0')
export const MicIcon = make('M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zM19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8')
export const BriefcaseIcon = make('M20 7H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2ZM16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2M12 12v5M9.5 14.5h5')
export const SparklesIcon = make('m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z')
export const InboxIcon = make('M22 12h-6l-2 3h-4l-2-3H2M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11Z')
export const CalendarIcon = make('M6 2v4M18 2v4M3 9h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z')
export const PlugIcon = make('M12 22v-5M9 8V2M15 8V2M18 8v3a6 6 0 0 1-12 0V8h12Z')

export type SidebarIconName = 'dashboard' | 'prospects' | 'sequences' | 'outreach' | 'compliance' | 'help' | 'chat' | 'playbook' | 'campaign' | 'analytics' | 'settings' | 'brain' | 'dollar-sign' | 'flask' | 'queue' | 'zap' | 'flame' | 'video' | 'megaphone' | 'admin' | 'trending-up' | 'memory' | 'globe' | 'bell' | 'mic' | 'briefcase' | 'sparkles' | 'inbox' | 'calendar' | 'plug'

// eslint-disable-next-line react-refresh/only-export-components
export const iconMap: Record<SidebarIconName, React.FC<IconProps>> = {
  dashboard: DashboardIcon,
  prospects: ProspectsIcon,
  sequences: SequencesIcon,
  outreach: OutreachIcon,
  compliance: ComplianceIcon,
  help: HelpIcon,
  chat: ChatIcon,
  playbook: PlaybookIcon,
  campaign: CampaignIcon,
  analytics: AnalyticsIcon,
  settings: SettingsIcon,
  brain: AnalyticsIcon, // Reuse analytics glyph for intelligence until a custom brain icon is added
  'dollar-sign': DollarSignIcon,
  flask: FlaskIcon,
  queue: QueueIcon,
  zap: ZapIcon,
  flame: FlameIcon,
  video: VideoIcon,
  megaphone: MegaphoneIcon,
  admin: ComplianceIcon, // Shield icon for admin section
  'trending-up': TrendingUpIcon,
  memory: MemoryIcon, // Brain/memory icon for agent memory dashboard
  globe: GlobeIcon, // TAG Intelligence Membrane dashboard
  bell: BellIcon, // Intelligence alerts
  mic: MicIcon,  // Conversation Intelligence
  briefcase: BriefcaseIcon, // Deal Briefings
  sparkles: SparklesIcon, // RFC-025 Discovery Feed
  inbox: InboxIcon, // RFC-045 v2.0 Inbound triage queue
  calendar: CalendarIcon,
  plug: PlugIcon,
}

export const SidebarIcon: React.FC<{ name: SidebarIconName; size?: number; className?: string }> = ({ name, size, className }) => {
  const Cmp = iconMap[name]
  return <Cmp size={size} className={className} />
}
